import { render, staticRenderFns } from "./modalClientes.vue?vue&type=template&id=20bdead8&scoped=true&"
import script from "./modalClientes.vue?vue&type=script&lang=js&"
export * from "./modalClientes.vue?vue&type=script&lang=js&"
import style0 from "./modalClientes.vue?vue&type=style&index=0&id=20bdead8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bdead8",
  null
  
)

export default component.exports